var render, staticRenderFns
import script from "./BarGraphic.vue?vue&type=script&lang=js"
export * from "./BarGraphic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9871f7a8')) {
      api.createRecord('9871f7a8', component.options)
    } else {
      api.reload('9871f7a8', component.options)
    }
    
  }
}
component.options.__file = "src/ui/components/BarGraphic.vue"
export default component.exports